// extracted by mini-css-extract-plugin
module.exports = {"blurbHeaderWrapper":"_fa1dc0c4","newBadge":"_cc70fa7a","coachmarkWrapper":"_1c576b63","tooltipHeader":"_3a427e89","tooltipBody":"_87a26a6","tooltipButtonWrapper":"_bd6dc013"};